import {TableCell} from '@mui/material'
import StatusCell from './StatusCell'

const stripHtmlTags = (html) => {
    if (!html) return ''
    const tmp = document.createElement('DIV')
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ''
}

const TableCellRenderer = ({header, item, iconsMap}) => {
    if (header === 'youtubeStatus') {
        return (
            <StatusCell
                key={header}
                iconsMap={iconsMap}
                statusKey={item[header]}
            />
        )
    }

    if (header === 'youtubeError' && item[header]) {
        return <TableCell key={header}>{stripHtmlTags(item[header])}</TableCell>
    }

    return <TableCell key={header}>{item[header]}</TableCell>
}

export default TableCellRenderer
